export default "__VITE_ASSET__CE$JKe6$__"